import { readableColor, mix, opacify, toHex } from "color2k";
import type { TeamInfoReturnType } from "./getTeamInfo";

export const readableColorMap = {
  "#000": "cui-text-fg-global-black",
  "#fff": "cui-text-fg-global-white",
};

export type ForceReadabilityType = {
  type?: "onLight" | "onDark" | "onColor" | "onTeamPrimary" | "onTeamSecondary";
  color?: string;
};

export type UseForceReadabilityProps = {
  forceReadability?: ForceReadabilityType;
  teamInfo?: TeamInfoReturnType;
};

export const useForceReadability = (props?: UseForceReadabilityProps) => {
  if (!props || !props?.forceReadability) return { readableToken: null, hasForceReadability: false };;
  const {
    teamInfo,
    forceReadability,
  } = props;
  let readable = {
    result: "",
    token: "",
  };

  const hasForceReadability =
    !!forceReadability && typeof forceReadability === "object";

  if (hasForceReadability) {
    if (forceReadability?.type === "onLight") readable.result = "#000";
    if (forceReadability?.type === "onDark") readable.result = "#fff";

    const forceReadabilityIsColor =
      forceReadability?.type === "onColor" &&
      typeof forceReadability?.color === "string";
    const containsColorMix =
      forceReadabilityIsColor && forceReadability?.color?.includes("color-mix");

    if (!!teamInfo && teamInfo.name) {
      if (forceReadability?.type === "onTeamPrimary")
        readable.result = readableColor(
          teamInfo?.metadata?.colors?.primary.value ?? ""
        );
      if (forceReadability?.type === "onTeamSecondary")
        readable.result = readableColor(
          teamInfo?.metadata?.colors?.secondary.value ?? ""
        );
    }

    // If forceReadability is a color;
    if (
      forceReadabilityIsColor &&
      /#/.test(forceReadability.color ?? "") &&
      !containsColorMix
    )
      readable.result = readableColor(forceReadability?.color ?? "");
    if (containsColorMix && typeof forceReadability?.color === "string") {
      const colorParts = forceReadability?.color
        .replace("color-mix(in srgb, ", "")
        .replace(")", "")
        .split(", ");
      const _color = toHex(
        mix(colorParts[0], opacify(colorParts[1], 0.4), 0.5)
      );
      readable.result = readableColor(_color);
    }
    readable.token = readableColorMap[readable.result];
  }
  const _readableToken = hasForceReadability ? readable?.token : undefined;
  return { readableToken: _readableToken, readable, hasForceReadability };
};
